/**
 * Vocabulary of the season Allocations sheet ("P24 Resort Team Sheet 2627"),
 * as served by /api/repData: `Staff Type` is `Rep` or `Office - Delivery`;
 * `tenant` is `nuco` | `wasteland` | `whiteroad` (from the sheet's `Brand`
 * column) or null when the brand code is unknown.
 */

/** `Staff Type` values that get the office treatment (visible across brands to managers). */
export const OFFICE_STAFF_TYPES = ['Office - Delivery']

export function isOfficeStaff(rep) {
  return OFFICE_STAFF_TYPES.includes(rep?.['Staff Type'])
}

/** Badge / row colour per tenant, office staff in their own colour. */
export const TENANT_COLOURS = {
  nuco: '#642b3b',
  wasteland: '#00bae3',
  whiteroad: '#919ea6'
}

export const OFFICE_COLOUR = '#16a085'

/** Text for the profile badge: the staff type for office staff, else the tenant (or staff type when the brand is unknown). */
export function repBadgeLabel(rep) {
  if (!rep) return ''
  const label = isOfficeStaff(rep) ? rep['Staff Type'] : (rep.tenant || rep['Staff Type'] || '')
  return String(label).toUpperCase()
}

/** `Approved Vehicles` is `Yes` / `No`; there is no separate driver column any more. */
export function isApprovedDriver(rep) {
  return String(rep?.['Approved Vehicles'] ?? '').trim().toLowerCase() === 'yes'
}
